export var SET_CONTENT_AVAILABILITY = "SET_CONTENT_AVAILABILITY";
